import React, { ReactElement } from "react";

import { StyledIcon } from "./Icon.styled";
import IconProps from "./IconProps";

const Icon = (props: IconProps): ReactElement => <StyledIcon {...props} />;

export default React.memo(Icon);
